<template>
    <section class="app-main">

        <div class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="handleShow()">添加权限</el-button >
        </div>
        <el-card shadow="hover">
            <el-table :data="tableData"  empty-text="暂无栏目" max-height="650"  style="width:100%;">
                <el-table-column prop="title"   label="名称"    width="350" ></el-table-column>
                <el-table-column label="权限列表" >
                    <template slot-scope="scope">
                        <el-popover placement="top" trigger="click"  v-for="(it,index) in scope.row.rules" :key="index">
                            <el-button type="success" plain size="small" @click="handleShow(it)" style="margin-right:30px;">编辑</el-button>
                            <el-button type="danger"  plain size="small" @click="handleDel(it)">删除</el-button>
                            <el-button slot="reference" style="margin-right:30px;">{{it.title}}</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 修改角色的弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="800px" center>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>权限名称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="title" placeholder="请输入栏目名称"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>后端方法：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="method" placeholder="请输入栏目路径"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>后端控制器：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="model" placeholder="请输入栏目控制器"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>状态：</p>
                </el-col>
                <el-col :span="18">
                    <el-radio v-model="status" :label="1" border>启用</el-radio>
                    <el-radio v-model="status" :label="0" border>禁用</el-radio>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>选择栏目：</p>
                </el-col>
                <el-col :span="18">
                    <el-select v-model="cid" filterable placeholder="请选择">
                        <el-option v-for="item in tableData" :key="item.id" :label="item.title" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>


    </section>
</template>


<script>
import { permission, permission_add, permission_put, permission_del } from '@/api/platform.js'

export default {
    data() {
        return {
            tableData: [],
            dialog:false,    // 控制显示 添加修改弹窗
            dialogTitle:'添加栏目',
            id:'',           //  有id 是修改  没有id是添加
            title:'',
            cid:[],
            method:'',
            model:'',
            status:1,
        }
    },
    methods: {
      handleCid(){
        console.log(this.cid)
      },
    // 获取栏目数据
    handleData(){
        permission().then(res => {
            if(res){
                this.tableData = res.data
            }
        }).catch(err => {
            console.log(err)
        })
    },
        // 显示添加修改弹窗
        handleShow(row){
            if(row){
                console.log(row)
                this.dialog      = true
                this.dialogTitle = '修改权限'
                this.id        = row.id
                this.title     = row.title
                this.method    = row.method
                this.model     = row.model
                this.status    = row.status
                this.cid       = row.cid
            }else{
                this.dialog      = true
                this.dialogTitle = '添加权限'
                this.id        = ''
                this.title     = ''
                this.method    = ''
                this.model     = ''
                this.status    = 1
                this.cid       = ''
  
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        // 添加栏目函数
        handleAdd(){
            let params = {
                title:this.title,
                method:this.method,
                model:this.model,
                status:this.status,
                cid:this.cid,
            }
            permission_add(params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改栏目函数
        handlePut(){
            let params = {
                title:this.title,
                method:this.method,
                model:this.model,
                status:this.status,
                cid:this.cid,
            }
            permission_put(this.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                    
                }
            })
        },
        // 修改排序
        handleSort(row){
            let params = {
                sort_id:row.sort_id
            }
            permission_put(row.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改状态
        handleStatus(row){
            let params = {
                status:row.status
            }
            permission_put(row.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
         // 点击删除 
        handleDel(it){

            this.$confirm(`此操作将删除 ${it.title} 权限, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                permission_del(it.id).then(res => {
                    this.$message({type:'success',message:res.msg})
                    this.handleData();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
    },
    created(){
        this.handleData();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
section{
    .top-btn {
        width: 120px;
        margin-right: 15px;
    }
    .line-item {
        margin-bottom: 20px;
    }
    .input-left {
        height: 40px;
        line-height: 40px;
    }
}
</style>